import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const useGroupeValidation = (groupeId) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!groupeId) {
      navigate("/connexion");
      return;
    }

    axios.get(`${process.env.REACT_APP_API}/groupes/${groupeId}`)
      .then((res) => {
        if (!res.data || res.data.expire) {
          localStorage.removeItem("groupeId");
          sessionStorage.removeItem("groupeId");
          navigate("/connexion");
        }
      })
      .catch(() => {
        localStorage.removeItem("groupeId");
        sessionStorage.removeItem("groupeId");
        navigate("/connexion");
      });
  }, [groupeId]);
};

export default useGroupeValidation;
